import { Source } from '@atlassian/mpac-types';
import { appListingLink, encodeAppName } from '@atlassian/mpac-utils';
export const mpacHosting = hosting => {
  switch (hosting) {
    case 'cloud':
      return 'cloud';
    case 'server':
      return 'server';
    case 'dataCenter':
      return 'datacenter';
    default:
      {
        console.error('Invalid hosting provided : ' + hosting);
        return '';
      }
  }
};
export const resolveHosting = tileData => {
  const {
    deployments,
    documentType
  } = tileData;
  if (!deployments.includes('cloud')) {
    return mpacHosting(documentType);
  }
  return 'cloud';
};
export const getAppListingUrl = (source, hostUrl, tileData, mountPath) => {
  // In case of source as PRODUCT, mountPath can have values like '/jira/marketplace'.
  if (source === Source.PRODUCT) {
    return "".concat(mountPath, "/discover/app/").concat(tileData.addonKey);
  }
  const url = appListingLink(hostUrl).expand({
    appId: tileData.addonId.toString(),
    slug: encodeAppName(tileData.name),
    hosting: resolveHosting(tileData),
    tab: 'overview'
  });
  return url;
};
export const onTileClick = (tileData, source, hostUrl, mountPath, history) => {
  const appListingUrl = getAppListingUrl(source, hostUrl, tileData, mountPath);
  // If the source is PRODUCT, navigate to the app listing URL within the same tab using history.push.
  // Otherwise, open the app listing URL in a new browser tab.
  if (source === Source.PRODUCT) {
    history === null || history === void 0 ? void 0 : history.push(appListingUrl);
  } else {
    window.open(appListingUrl);
  }
};